import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';

import { addDiscussionDocument } from '../../utils/jsonapi-functions/discussions';
import { createDocument } from '../../utils/jsonapi-functions/documents';
import { getPermissionId, getCampaignId } from '../../selectors/campaign-selectors';
import { getDiscussionId, getDiscussionName } from '../../selectors/discussion-selectors';
import { BRIEF, CONTRACT, SIGNED_CONTRACT, DOCUMENT, DISCUSSION_PAGE } from '../../utils/static-configuration';
import { reportError } from '../../utils/error-handling-service';
import { trackEvent } from '../../utils/metric-analytics-service';
import { CREATE_DOCUMENT } from './constants';
import { MODAL_LOADING, MODAL_ERROR, MODAL_CLEAR } from '../../constants/modal';
import { SEND_MESSAGE, UPDATE_DOCUMENTS, UPDATE_CURRENT_BRIEF, UPDATE_CURRENT_CONTRACT, UPDATE_SIGNED_CONTRACT } from '../../containers/discussion/constants';

export function* createNewDocument(action) {
  const documentData = action.documentData;
  const createDocumentCallback = action.createDocumentCallback;
  const discussionId = yield select(getDiscussionId);
  documentData.discussionId = discussionId;

  try {
    yield put({ type: MODAL_LOADING, loading: true });

    const newDocument = yield call(createDocument, documentData);
    const newDocumentJSON = newDocument.toJSONTree();
    const docType = newDocumentJSON.docType;
    const docId = newDocumentJSON.id;
    const discussionName = yield select(getDiscussionName);
    const campaignId = yield select(getCampaignId);

    // Update discussion with new document
    yield call(addDiscussionDocument, discussionId, newDocument);

    const uploadDocumentData = {
      campaignId: campaignId,
      collaborationId: discussionId,
      collaborationName: discussionName,
      docId,
    };

    // Update document and deliverable local state
    yield put({ type: UPDATE_DOCUMENTS, documentData: fromJS(newDocumentJSON) });
    if (docType === BRIEF) {
      yield put({ type: UPDATE_CURRENT_BRIEF, currentBrief: docId });
      trackEvent('Upload Brief', uploadDocumentData);
    } else if (docType === CONTRACT) {
      yield put({ type: UPDATE_CURRENT_CONTRACT, currentContract: docId });
      trackEvent('Upload Contract', uploadDocumentData);
    } else if (docType === SIGNED_CONTRACT) {
      yield put({ type: UPDATE_SIGNED_CONTRACT, signedContract: docId });
      trackEvent('Upload Signed Contract', uploadDocumentData);
    } else if (docType === DOCUMENT) {
      trackEvent('Upload File', uploadDocumentData);
    }

    // Send new message
    const myPermissionId = yield select(getPermissionId);
    const messageType = docType.toLowerCase();
    const message = newDocumentJSON.name;
    const metaData = {
      messageType,
      discussionId,
      permissionId: myPermissionId,
      docId: newDocumentJSON.id,
      docStatus: 'added',
    };

    const messageData = {
      message,
      metaData,
      page: DISCUSSION_PAGE,
    };
    yield put({ type: SEND_MESSAGE, data: messageData });

    yield call(createDocumentCallback);
    yield put({ type: MODAL_CLEAR });
  } catch (error) {
    reportError('CREATE_DOCUMENT_ERROR', error.message);
    yield put({ type: MODAL_ERROR, error });
  }
}

export function* watchCreateDocument() {
  yield takeLatest(CREATE_DOCUMENT, createNewDocument);
}

export default function* documentUploadSaga() {
  yield [fork(watchCreateDocument)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/document-upload-modal/sagas.js
 **/